module.exports = __webpack_public_path__ + "img/tucson-plug-in-hybrid-25.f341f4ab.png";